// import React from "react";
// import { STATE_CONSTANTS_LOGIN } from "../../utils/useConstantState";
// import LoginCompleteProfile from "./render/Login.CompleteProfile";
// import LoginCountryCode from "./render/Login.CountryCode";
// import LoginOTP from "./render/Login.OTP";
// import LoginPhoneNumber from "./render/Login.Phonenumber";
// import TH from "../../utils/PhoneNumber/flags/th.png";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

// const LoginMain = () => {
//   const { user } = useSelector((state) => state.auth);
//   const navigate = useNavigate();
//   const [tab, setTab] = React.useState(STATE_CONSTANTS_LOGIN.PHONE_NUMBER);
//   const [contry, setContry] = React.useState({
//     label: "Thailand",
//     value: "66",
//     code: "TH",
//     image: TH,
//   });

//   const [username, setUserName] = React.useState("");
//   const [mongoId, setMongoId] = React.useState("");

//   React.useEffect(() => {
//     if (user?._id) {
//       navigate("/Profile");
//     } else {
//       return;
//     }
//   }, [user]);

//   if (tab === STATE_CONSTANTS_LOGIN.PHONE_NUMBER) {
//     return (
//       <LoginPhoneNumber
//         setTab={setTab}
//         contry={contry}
//         setUserName={setUserName}
//         setMongoId={setMongoId}
//       />
//     );
//   } else if (tab === STATE_CONSTANTS_LOGIN.COUNTRY_CODE) {
//     return (
//       <LoginCountryCode setTab={setTab} setContry={setContry} contry={contry} />
//     );
//   } else if (tab === STATE_CONSTANTS_LOGIN.OTP) {
//     return <LoginOTP setTab={setTab} username={username} />;
//   } else if (tab === STATE_CONSTANTS_LOGIN.COMPLETE_PROFILE) {
//     return (
//       <LoginCompleteProfile
//         setTab={setTab}
//         mongoId={mongoId}
//         contry={contry}
//         username={username}
//       />
//     );
//   } else {
//     return <LoginPhoneNumber setTab={setTab} setMongoId={setMongoId} />;
//   }
// };
// export default LoginMain;

import React from "react";
import { STATE_CONSTANTS_LOGIN } from "../../utils/useConstantState";
import LoginCompleteProfile from "./render/Login.CompleteProfile";
import LoginCountryCode from "./render/Login.CountryCode";
import LoginOTP from "./render/Login.OTP";
import LoginPhoneNumber from "./render/Login.Phonenumber";
import TH from "../../utils/PhoneNumber/flags/thai.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SystemStoreBasketAddress } from "../../utils/useStorage";
import { ContextCart } from "../../context/Context.Cart";

const LoginMain = () => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [tab, setTab] = React.useState(STATE_CONSTANTS_LOGIN.PHONE_NUMBER);
  const [contry, setContry] = React.useState(null);

  const [username, setUserName] = React.useState("");
  const [mongoId, setMongoId] = React.useState("");
  const [uniqueKey, setUniqueKey] = React.useState("");
  const [isNewKey, setIsNewKey] = React.useState(false);
  const [isFirstLogin, setIsFirstLogin] = React.useState(false);
  const [value, setValue] = React.useState("");

  const { cart } = React.useContext(ContextCart);
  const address = SystemStoreBasketAddress((state) => state.address);
  const selected = cart?.filter((item) => {
    return item.type === "PACKAGE";
  });

  // console.log("address", {
  //   address,
  //   selected,
  //   tab,
  //   isNewKey,
  //   isFirstLogin,
  //   uniqueKey,
  //   user,
  //   contry,
  //   username,
  //   mongoId,
  //   value,
  //   cart,
  //   selected,
  // });

  React.useEffect(() => {
    const oldContry = JSON.parse(localStorage.getItem("contry-code"));

    if (oldContry) {
      setContry(oldContry);
    } else {
      setContry({
        label: "Thailand",
        value: "66",
        code: "TH",
        image: TH,
      });
    }
  }, []);

  React.useEffect(() => {
    document?.getElementById("root")?.scrollIntoView({
      behavior: "auto",
      block: "start",
    });
  }, [tab]);

  React.useEffect(() => {
    const isNew = sessionStorage.getItem("create-new");
    const isPayment = sessionStorage.getItem("payment");

    if (address && selected?.length > 0) {
      sessionStorage.setItem("payment", true);
    }
    if (isNew === "true") {
      if (isPayment) {
        sessionStorage.removeItem("payment");
        sessionStorage.removeItem("create-new");
        navigate("/Basket");
      } else {
        sessionStorage.removeItem("create-new");
        navigate("/OurServices");
      }
    } else if (user?._id) {
      navigate("/MyProfile");
    } else {
      return;
    }
  }, [user]);

  React.useEffect(() => {
    const anotherLogin = JSON.parse(sessionStorage.getItem("login-footer"));
    if (anotherLogin?.value) {
      setValue(anotherLogin.value);
      setContry(anotherLogin.country);
      setTab(STATE_CONSTANTS_LOGIN.OTP);
      sessionStorage.removeItem("login-footer");
    }
  }, [sessionStorage]);

  if (contry === null) {
    return <div className="h-screen"></div>;
    // return <React.Fragment />;
  }

  if (tab === STATE_CONSTANTS_LOGIN.PHONE_NUMBER) {
    return (
      <LoginPhoneNumber
        setTab={setTab}
        contry={contry}
        setValue={setValue}
        value={value}
      />
    );
  } else if (tab === STATE_CONSTANTS_LOGIN.COUNTRY_CODE) {
    return (
      <LoginCountryCode setTab={setTab} setContry={setContry} contry={contry} />
    );
  } else if (tab === STATE_CONSTANTS_LOGIN.OTP) {
    return (
      <LoginOTP
        setTab={setTab}
        username={username}
        setMongoId={setMongoId}
        uniqueKey={uniqueKey}
        phoneCode={contry?.value}
        isNewKey={isNewKey}
        setIsNewKey={setIsNewKey}
        setIsFirstLogin={setIsFirstLogin}
        isFirstLogin={isFirstLogin}
        contry={contry}
        setUniqueKey={setUniqueKey}
        setUserName={setUserName}
        value={value}
      />
    );
  } else if (tab === STATE_CONSTANTS_LOGIN.COMPLETE_PROFILE) {
    return (
      <LoginCompleteProfile
        setTab={setTab}
        mongoId={mongoId}
        contry={contry}
        username={username}
      />
    );
  } else {
    return <div className="h-screen"></div>;
    // return (
    //   <LoginPhoneNumber
    //     setUniqueKey={setUniqueKey}
    //     setTab={setTab}
    //     setMongoId={setMongoId}
    //     setIsNewKey={setIsNewKey}
    //     setIsFirstLogin={setIsFirstLogin}
    //     isFirstLogin={isFirstLogin}
    //     contry={contry}
    //     setValue={setValue}
    //     value={value}
    //   />
    // );
  }
};
export default LoginMain;
